import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import type { Slice } from "@/store/store.decl";

type AiAssistProUpsellStoreState = {
  dismissedUsers: Record<string, true>;
  dismiss: (userId: string) => void;
};

const createAiAssistProUpsellSlice: Slice<AiAssistProUpsellStoreState> = (
  set
) => ({
  dismissedUsers: {},
  dismiss: (userId) => {
    set((state) => ({
      dismissedUsers: { ...state.dismissedUsers, [userId]: true },
    }));
  },
});

/** Persists AI Assist Pro upsell dismissal per user on this browser. */
export const useAiAssistProUpsellStore = create<AiAssistProUpsellStoreState>()(
  persist(createAiAssistProUpsellSlice, {
    name: "conversation-center-ai-assist-pro-upsell",
    storage: createJSONStorage(() => localStorage),
  })
);
